import { useEffect } from "react";

import TwitterShare from "./TwitterShare";

import "../css/FinalScore.css";

export default function FinalScore({ accuracy, wordCount, onReset }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && onReset != null) {
        onReset();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onReset]);

  return (
    <div className="finalScoreContainer">
      <div className="finalScoreText">
        {"You scored "}
        <strong className="finalScoreValue">{wordCount + " lwpm "}</strong>
        {" with an accuracy of "}
        <strong className="finalScoreValue">{accuracy}</strong>
      </div>
      <div className="restartText">Press [Enter] to restart</div>
      <TwitterShare accuracy={accuracy} wordCount={wordCount} />
    </div>
  );
}
